"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollGradient = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var useRightInScrollable_1 = require("./hooks/useRightInScrollable");
var useScrollEvent_1 = require("./hooks/useScrollEvent");
var useGradientColor_1 = require("./hooks/useGradientColor");
/**
 * @internal
 */
exports.ScrollGradient = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? "#FFFFFF" : _b, _c = _a.size, size = _c === void 0 ? 20 : _c, className = _a.className, contentClassName = _a.contentClassName, onScroll = _a.onScroll, children = _a.children;
    var _d = useRightInScrollable_1.useRightInScrollable(), right = _d.right, content = _d.content, setContent = _d.setContent;
    var _e = useScrollEvent_1.useScrollEvent(content, size / 2, onScroll), top = _e.top, bottom = _e.bottom, onScrollHandler = _e.onScrollHandler;
    var _f = useGradientColor_1.useGradientColor(backgroundColor), topBackground = _f.topBackground, bottomBackground = _f.bottomBackground;
    return (react_1.default.createElement("div", { className: classnames_1.default("gd-gradient-wrapper", className) },
        react_1.default.createElement("div", { className: classnames_1.default("gd-gradient-top"), style: { right: right, opacity: top, height: size, background: topBackground } }),
        react_1.default.createElement("div", { className: classnames_1.default("gd-gradient-content", contentClassName), onScroll: onScrollHandler, ref: setContent }, children),
        react_1.default.createElement("div", { className: classnames_1.default("gd-gradient-bottom"), style: { right: right, opacity: bottom, height: size, background: bottomBackground } })));
};
//# sourceMappingURL=ScrollGradient.js.map